import { render } from "./MediaLibrary.vue?vue&type=template&id=188beee2&scoped=true"
import script from "./MediaLibrary.vue?vue&type=script&lang=js"
export * from "./MediaLibrary.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-188beee2"

export default script